module.exports = __webpack_public_path__ + "img/open-table.95b53c55.svg";